import React, { useEffect, useMemo, useState } from "react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { styled } from "@mui/system";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "layouts/authentication/sign-in";

const Container = styled(Box)(({ theme }) => ({
  background: "#F0F2F5",
  backgroundPosition: "center",
  padding: "2rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
}));

const Form = styled("form")(({ theme }) => ({
  background: "rgba(255, 255, 255, 0.8)",
  padding: "2rem",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  width: "400px",
}));

const Input = styled(TextField)(({ theme }) => ({
  marginBottom: "1rem",
  width: "100%",
}));

const Title = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  marginBottom: "1rem",
}));

const ReferFriendForm = () => {
  const sessionId = useSelector((state) => state.session.sessionId);
  const user_id = useSelector((state) =>
    state.session.setUserId ? state.session.setUserId.value : null
  );
  const user_name = useSelector((state) =>
    state.session.setUserName ? state.session.setUserName.value : null
  );

  const navigate = useNavigate();

  const isSessionIdValid = useMemo(() => {
    return sessionId !== null && sessionId !== undefined;
  }, [sessionId]);

  useEffect(() => {
    if (!isSessionIdValid) {
      navigate("/authentication/sign-in");
      console.log("test");
    } else {
      console.log(sessionId, "sessionId");
    }
  }, [sessionId, navigate]);

  const [formValues, setFormValues] = useState({
    refferid_c: "",
    firstname_c: "",
    lastname_c: "",
    email_c: "",
    phone_number_c: "",
    relationship_c: "",
    agree: false,
  });

  const [showRelationship, setShowRelationship] = useState(false);

  const relationships = [
    { label: "Husband", value: "husband" },
    { label: "Wife", value: "wife" },
    { label: "Father", value: "father" },
    { label: "Mother", value: "mother" },
    { label: "Son", value: "son" },
    { label: "Daughter", value: "daughter" },
    { label: "Brother", value: "brother" },
    { label: "Sister", value: "sister" },
    { label: "Grandfather (Paternal)", value: "grandfatherPaternal" },
    { label: "Grandmother (Paternal)", value: "grandmotherPaternal" },
    { label: "Grandfather (Maternal)", value: "grandfatherMaternal" },
    { label: "Grandmother (Maternal)", value: "grandmotherMaternal" },
    { label: "Uncle", value: "uncle" },
    { label: "Aunt", value: "aunt" },
    { label: "Nephew", value: "nephew" },
    { label: "Niece", value: "niece" },
    { label: "Cousin", value: "cousin" },
    { label: "Others", value: "others" },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "agree") {
      setShowRelationship(checked);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Values:", formValues);
    console.log("User ID:", user_id);

    const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/service/v4_1/rest.php";
    const method = "set_entry";
    const input_type = "JSON";
    const response_type = "JSON";

    const rest_data = JSON.stringify({
      session: sessionId,
      module_name: "Ref_Refferals",
      name_value_list: [
        { name: "refferid_c", value: formValues.refferid_c },
        { name: "referralname_c", value: user_name },
        { name: "firstname_c", value: formValues.firstname_c },
        { name: "lastname_c", value: formValues.lastname_c },
        { name: "email_c", value: formValues.email_c },
        { name: "phone_number_c", value: formValues.phone_number_c },
        { name: "relationship_c", value: formValues.relationship_c },
        { name: "is_relation_c", value: formValues.agree },
        { name: "user_id_c", value: user_id },
      ],
    });

    console.log(rest_data);

    const fullUrl = `${apiUrl}?method=${method}&input_type=${input_type}&response_type=${response_type}&rest_data=${encodeURIComponent(
      rest_data
    )}`;

    try {
      const response = await axios.post(fullUrl);
      console.log("API Response:", response.data, "test");
      alert("Referral submitted successfully!");
      navigate("/myReferral");
    } catch (error) {
      if (error.response) {
        console.error("An error occurred during login:", error.response.data);
        console.error("Status code:", error.response.status);
        alert("Error submitting referral: " + error.response.data.message);
      } else if (error.request) {
        console.error("No response received:", error.request);
        alert("No response received from server");
      } else {
        console.error("Error setting up request:", error.message);
        alert("Error setting up request: " + error.message);
      }
    }
  };

  return (
    <>
      {!sessionId ? (
        <Login />
      ) : (
        <div>
          <DashboardNavbar />
          <Container>
            <Form onSubmit={handleSubmit}>
              <Title variant="h5" component="h2" gutterBottom>
                Refer A Friend
              </Title>
              <Input
                label="Friend First Name"
                variant="outlined"
                fullWidth
                name="firstname_c"
                value={formValues.firstname_c}
                onChange={handleChange}
                required
              />
              <Input
                label="Friend Last Name"
                variant="outlined"
                fullWidth
                name="lastname_c"
                value={formValues.lastname_c}
                onChange={handleChange}
                required
              />
              <Input
                label="Email"
                type="email"
                variant="outlined"
                fullWidth
                name="email_c"
                value={formValues.email_c}
                onChange={handleChange}
                required
              />
              <Input
                label="Phone Number"
                type="tel"
                variant="outlined"
                fullWidth
                name="phone_number_c"
                value={formValues.phone_number_c}
                onChange={handleChange}
                required
              />

              <FormControlLabel
                control={
                  <Checkbox name="agree" checked={formValues.agree} onChange={handleChange} />
                }
                label="The referred person is my relative"
                style={{ marginBottom: "1rem" }}
              />

              {showRelationship && (
                <>
                  <FormControl
                    fullWidth
                    sx={{
                      mb: 2,
                      "& .MuiInputBase-root": {
                        height: 44,
                      },
                    }}
                  >
                    <InputLabel id="relationship-label">Relationship</InputLabel>
                    <Select
                      labelId="relationship-label"
                      id="relationship_c"
                      name="relationship_c"
                      value={formValues.relationship_c}
                      label="Relationship"
                      onChange={handleChange}
                      required
                    >
                      {relationships.map((relation) => (
                        <MenuItem key={relation.value} value={relation.value}>
                          {relation.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <Typography  sx={{ color: "#012034", fontSize:"12px", fontWeight: "bold", textAlign:"center", marginTop:"5px", fontStyle:"italic"}}>
                     Note: Enter Your Relationship to Him/Her
                    </Typography>
                  </FormControl>
                </>
              )}

              <Button
                type="submit"
                variant="gradient"
                fullWidth
                sx={{
                  backgroundColor: "#2B84EB",
                  color: "#ffffff",
                  width: "100%",
                  padding: "6px 8px",
                  fontSize: "1rem",
                  "&:hover": {
                    backgroundColor: "#2B84EB",
                  },
                }}
              >
                Submit
              </Button>
            </Form>
          </Container>
        </div>
      )}
    </>
  );
};

export default ReferFriendForm;
